<!-- A horizontally-scrolling block with hidden scrollbar -->

<template>
  <div class="HorizontalScroller">
    <slot />
  </div>
</template>

<style scoped>
.HorizontalScroller {
  overflow-x: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
}
.HorizontalScroller::-webkit-scrollbar {
  display: none;
}
</style>
